import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import VendorAttributionLabel from '../../../shared/VendorAttributionLabel';
import BibSeries from '../../../shared/BibSeries';

import './SimilarSeries.scss';

function makeBib(metadataId, title, imageUrl) {
  return {
    metadataId,
    title,
    format: 'BK',
    coverImage: {
      type: 'NONLOCAL',
      local_url: imageUrl,
      providerURI: 'https://novselect.ebscohost.com/'
    }
  };
}

export default class SimilarSeries extends React.PureComponent {
  render() {
    const source = 'novelist';
    const bibs = Immutable.fromJS([
      makeBib(
        'S26C513402',
        'Void trilogy',
        'https://secure.syndetics.com/index.aspx?isbn=9781400157273/MC.GIF&client=ottap&type=xw12&oclc='
      ),
      makeBib(
        'S26C422868',
        "Old Man's War universe",
        'https://secure.syndetics.com/index.aspx?isbn=9780765394859/MC.GIF&client=ottap&type=xw12&oclc='
      ),
      makeBib(
        'S26C199946',
        'Shadow series (Orson Scott Card)',
        'https://secure.syndetics.com/index.aspx?isbn=9781435235045/MC.GIF&client=ottap&type=xw12&oclc='
      )
    ]);

    return (
      <div className="cp-similar-series">
        <div className="similar-series-heading">
          <FormattedMessage tagName="h3" id="similar_series" />
          <VendorAttributionLabel name={source} />
        </div>

        <BibSeries bibs={bibs} />
      </div>
    );
  }
}
